<template>
    <div v-if="cookieAccepted">
        <div v-if="openAdvanced" class="cookie__big">
            <div class="wrapper">
                <div class="cookie__in">
                    <div class="cookie__big-top">
                        <div class="cookie__big-headline">
                            <span>{{trans.text.cookies.title}}</span>
                        </div>

                        <div class="cookie__big-items">
                            <div class="cookie__big-item">
                                <div class="cookie__big-item_content">
                                    <div class="inp-group">
                                        <input class="inp-group__checkbox" id="styled-checkbox-cookie-1" type="checkbox" checked disabled>
                                        <label for="styled-checkbox-cookie-1">
                                            <h5>{{trans.text.cookies.functional}}</h5>
                                            <p>{{trans.text.cookies.functionalInfo}}</p>
                                            <span class="checkbox"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="cookie__big-item">
                                <div class="cookie__big-item_content">
                                    <div class="inp-group">
                                        <input class="inp-group__checkbox" id="styled-checkbox-cookie-2" type="checkbox" v-model="cookies.performance">
                                        <label for="styled-checkbox-cookie-2">
                                            <h5>{{trans.text.cookies.performance}}</h5>
                                            <p>{{trans.text.cookies.performanceInfo}}</p>
                                            <span class="checkbox"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="cookie__big-item">
                                <div class="cookie__big-item_content">
                                    <div class="inp-group">
                                        <input class="inp-group__checkbox" id="styled-checkbox-cookie-3" type="checkbox" v-model="cookies.social_advertising">
                                        <label for="styled-checkbox-cookie-3">
                                            <h5>{{trans.text.cookies.social}}</h5>
                                            <p>{{trans.text.cookies.socialInfo}}</p>
                                            <span class="checkbox"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cookie__big-bottom">
                        <div class="cookie__big-bottom_l">
                            <button class="btn-green btn-block" @click="done()">{{trans.text.cookies.done}}</button>
                        </div>

                        <div class="cookie__big-bottom_r">
                            <p>{{trans.text.cookies.changeText}}</p><p>{{trans.text.cookies.viewOur}}
                            <a target="_blank" :href="'/'+ lang +'/page/privacy-cookie-policy'">{{trans.text.cookies.linkText}}</a> {{trans.text.cookies.fullDetails}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="cookie cookie__mini">
            <div class="wrapper">
                <div class="cookie__in">
                    <div class="cookie__l">
                        <button class="btn btn-green btn-block" @click="done">{{trans.text.cookies.acceptAll}}</button>
                        <button class="btn btn-gray btn-block" @click="toggleAdvanced">
                            <span>{{trans.text.cookies.settings}}</span>
                        </button>
                    </div> <!-- .cookie__l -->

                    <div class="cookie__r">
                        <div class="cookie__content">
                            <div class="cookie__headline">
                                <span>{{trans.text.cookies.cookiesForestal}}</span>
                            </div> <!-- .cookie__headline -->
                            <p>{{trans.text.cookies.cookiesForestalInfo1}}</p>
                            <p>{{trans.text.cookies.cookiesForestalInfo2}}</p>
                        </div> <!-- .cookie__content -->
                    </div> <!-- .cookie__r -->
                </div> <!-- .cookie__in -->
            </div> <!-- .wrapper -->
        </div> <!-- .cookie -->
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        props:['lang', 'trans'],
        name: "CookieComponent",
        data() {
            return {
                openAdvanced: false,
                cookies: {
                    performance: true,
                    social_advertising: true,
                }
            }
        },
        watch: {
            openAdvanced: function () {
                let body = document.body;
                let className = 'is-ovh';

                if (this.openAdvanced) {
                    body.classList.add(className);
                } else {
                    body.classList.remove(className);
                }
            }
        },
        computed: {
            accepted() {
                return this.$store.state.cookies.accepted
            },
            cookieAccepted() {
                return !this.accepted;
            }
        },
        methods: {
            ...mapActions(['apply']),
            done() {
                this.openAdvanced = false;
                this.apply(this.cookies);
            },
            toggleAdvanced() {
                this.openAdvanced = !this.openAdvanced;
            }
        }
    }
</script>

<style scoped>
    .cookie{
        display:block !important;
    }
</style>
